import React from 'react'

const QuePage = () => {
  return (
    <div>QuePage</div>
  )
}

export default QuePage